import AUTOMATON_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/automatonAvatar.webp';
import LIZARD_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/lizardAvatar.webp';
import MONKEY_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/monkeyAvatar.webp';
import MUERTOS_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/muertosAvatar.webp';
import MYSTIC_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/mysticAvatar.webp';
import QUEEN_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/queenAvatar.webp';
import SEER_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/seerAvatar.webp';
import SENTINEL_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/sentinelAvatar.webp';
import SQUIRREL_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/squirrelAvatar.webp';
import WIZARD_AVATAR_IMAGE_URL from '../assets/uniqueAvatars/wizardAvatar.webp';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ALL_UNIQUE_AVATAR_TYPES = [
    'automaton',
    'lizard',
    'monkey',
    'muertos',
    'mystic',
    'queen',
    'seer',
    'sentinel',
    'squirrel',
    'wizard'
];
export const ALL_UNIQUE_AVATAR_PROPERTIES = {
    automaton: { url: AUTOMATON_AVATAR_IMAGE_URL },
    lizard: { url: LIZARD_AVATAR_IMAGE_URL },
    monkey: { url: MONKEY_AVATAR_IMAGE_URL },
    muertos: { url: MUERTOS_AVATAR_IMAGE_URL },
    mystic: { url: MYSTIC_AVATAR_IMAGE_URL },
    queen: { url: QUEEN_AVATAR_IMAGE_URL },
    seer: { url: SEER_AVATAR_IMAGE_URL },
    sentinel: { url: SENTINEL_AVATAR_IMAGE_URL },
    squirrel: { url: SQUIRREL_AVATAR_IMAGE_URL },
    wizard: { url: WIZARD_AVATAR_IMAGE_URL }
};
